import { render, staticRenderFns } from "./PersonalInformationInput.vue?vue&type=template&id=6896295c&scoped=true"
import script from "./PersonalInformationInput.vue?vue&type=script&lang=ts"
export * from "./PersonalInformationInput.vue?vue&type=script&lang=ts"
import style0 from "./PersonalInformationInput.vue?vue&type=style&index=0&id=6896295c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896295c",
  null
  
)

export default component.exports